const DropdownArrowIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="3" y="4" width="18" height="18" rx="9" fill="#ECE9EE" />
            <path
                d="M9.44984 11L11.9998 13.4747L14.5498 11L15.3332 11.7653L11.9998 15L8.6665 11.7653L9.44984 11Z"
                fill="#262626"
            />
        </svg>
    );
};
export default DropdownArrowIcon;
